<script setup lang="ts">
</script>

<template>
  <table style="border-collapse: separate; border-spacing: 2px;">
    <slot />
  </table>
</template>
